export enum EstadoVerificacion {
  PENDIENTE = 'PENDIENTE',
  COMPLETA = 'COMPLETA',
}
